import { required, unique, shape, items, concatFailure } from '@totalsoft/pure-validations';

export const incomeSourceValidator = shape({
  orderNo: required,
  code: required,
  name: required,
  description: required,
  incomeSourceArea: required
});

export const incomeSourceDetailValidator = concatFailure(
  unique(x => x.orderNo || {}, 'IncomeSources.Detail.Validators.OrderIdUnique'),
  unique(x => x.code || {}, 'IncomeSources.Detail.Validators.CodeUnique'),
  items(
    shape({
      orderNo: required,
      code: required,
      name: required,
      description: required,
      dataTypeId: required
    })
  )
);
